var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7179_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.112 25V80.4375L149.969 101.375L103.112 25Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.112 25L56.25 101.375L103.112 80.4375V25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.112 137.302V174.97L150 110.102L103.112 137.302Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.112 174.97V137.295L56.25 110.102L103.112 174.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.112 128.582L149.969 101.376L103.112 80.4512V128.582Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25 101.376L103.112 128.582V80.4512L56.25 101.376Z",
    fill: "white",
    fillOpacity: 0.602
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7179_711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.80f86b5f36efbe5523c67f2609bc1fbc.svg";
export { ForwardRef as ReactComponent };